import { Backdrop, Box, CircularProgress, List, Typography } from '@mui/material';
import { FollowUpActionCommentItem } from './FollowUpActionCommentItem';
import { DisplayComment } from './useFollowUpActionComments';

interface FollowUpActionCommentsListProps {
    comments: DisplayComment[];
    loading: boolean;
    commentPendingDelete: DisplayComment | null;
    onRequestDelete: (comment: DisplayComment) => void;
    onCancelDelete: () => void;
    onConfirmDelete: () => void;
}

export const FollowUpActionComments = (props: FollowUpActionCommentsListProps) => {
    const { comments, loading, commentPendingDelete, onRequestDelete, onCancelDelete, onConfirmDelete } = props;

    return (
        <Box
            sx={{
                backgroundColor: 'white',
                paddingX: 2,
                position: 'relative',
                flex: 1,
                minHeight: 0,
                overflowY: 'auto'
            }}
        >
            {loading && (
                <Backdrop open sx={{ position: 'absolute', zIndex: (theme) => theme.zIndex.appBar - 1 }}>
                    <CircularProgress />
                </Backdrop>
            )}

            {!loading && comments.length === 0 && (
                <Box
                    sx={{
                        minHeight: '68vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        padding: 4
                    }}
                >
                    <Box
                        component="img"
                        src={`${STATIC_URL}i/comments_downstate.svg`}
                        alt=""
                        sx={{ width: 160, marginBottom: 2 }}
                    />
                    <Typography variant="h5" sx={{ whiteSpace: 'pre-line', color: 'text.secondary', fontWeight: 500 }}>
                        {_t('mobile_follow_up_actions_comments_empty_title')}
                    </Typography>
                    <Typography variant="subtitle1" sx={{ whiteSpace: 'pre-line', color: 'text.secondary' }}>
                        {_t('mobile_follow_up_actions_comments_empty_subtitle')}
                    </Typography>
                </Box>
            )}

            {!loading && comments.length > 0 && (
                <List disablePadding>
                    {comments.map((comment, index) => (
                        <FollowUpActionCommentItem
                            key={comment.id}
                            comment={comment}
                            isPendingDelete={commentPendingDelete?.id === comment.id}
                            showDivider={index < comments.length - 1}
                            onRequestDelete={onRequestDelete}
                            onCancelDelete={onCancelDelete}
                            onConfirmDelete={onConfirmDelete}
                        />
                    ))}
                </List>
            )}
        </Box>
    );
};
